import React, { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import DivRow from '../../components/controls/DivRow';
import DropDownInput from '../../components/controls/DropDownInput';
import Input from '../../components/controls/Input';
import Modal from 'react-modal';
import { tipoDocumentos } from '../../data/mochaData';
import { cedulaMask, cedulaPattern, customStyles, endPoints, MicrositioEnum, tipoId } from '../../utils/constanst';
import http from '../../services/http';
import CotizadorCRProvider, { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import Container from './Container';
import { ImgAlertOk } from '../../svg';

const Micrositio = ({ location, history, ...rest }) => {
    const letterPattern = "[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+";

    const dataDefault = { tipoId: '1', identificacion: '', nombre: '', apellido: '', email: '', celular: '', showDialogFinish: false, showAcceptModel: false, sendDisabled: false };

    const [data, setData] = useState(dataDefault);
    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorCRDataContext);

    useEffect(() => {

        setTimeout(() => {
            const preloader = document.querySelector('.site-preloader');

            if (preloader) {
                preloader.addEventListener('transitionend', (event) => {
                    if (event.propertyName === 'opacity') {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add('site-preloader__fade');
            }
        }, 600);

    }, [0]);

    const changeHandler = event => {
        let d = { ...data, [event.target.name]: event.target.value };
        setData(d);

        setPoliza({
            asegurado: {
                tipoId: d.tipoId,
                numId: d.identificacion,
                nombre: d.nombre,
                apellido: d.apellido,
                email: d.email,
                celular: d.celular
            }
        });
    }

    const onAcceptChange = (e) => {
        if (e.target.checked)
            openAcceptModal();
    }

    const closeAcceptModal = () => setData({ ...data, showAcceptModel: false });
    const openAcceptModal = () => setData({ ...data, showAcceptModel: true });

    const openModalFinish = () => setData({ ...data, showDialogFinish: true });
    const closeModalFinish = () => setData({ ...data, showDialogFinish: false });

    const sendNotification = () => {
        let result = document.querySelector('form').reportValidity();

        if (!result) return;

        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');
        data.nombres = data.nombre + ' ' + data.apellido;
        data["source"] = src;
        
        http(endPoints.notification).post({ ...data, micrositio: MicrositioEnum.Incendio});

        openModalFinish();

    }

    const finalizar = () => {
        closeModalFinish();
        window.location.href = '/ProductosDigitales/micrositio/incendiocr';

    }

    return (

        <Container>

            <div className="layout cotizadorcr" style={{ maxWidth: "580px" }}>
                <div className="header-section p10">
                    <h2 className="txt-esmeralda txt-light txt-center">¡Cotiza tu seguro Aquí!</h2>
                    <h3 className="txt-light txt-center">Protege lo más valioso, con tu póliza <br />
                        de Incendio Hogar
                    </h3>
                </div>
                <form action="" className="lfcontainer">
                    <div className="step">
                        <DivRow width='100%' >

                            {data.tipoId == tipoId.cedula &&

                                <DropDownInput label='Tipo de Identificación' dataProvider={tipoDocumentos}
                                    value={data.identificacion} onChange={changeHandler}
                                    valueSelect={data.tipoId} onChangeSelect={changeHandler}
                                    field='identificacion'
                                    fieldSelect='tipoId'
                                    mask="9-9999-9999"
                                    pattern="\d-\d\d\d\d-\d\d\d\d"
                                    title="Documento invalido"
                                />
                            }

                            {data.tipoId != tipoId.cedula &&

                                <DropDownInput label='Tipo de Identificación' dataProvider={tipoDocumentos}
                                    value={data.identificacion} onChange={changeHandler}
                                    valueSelect={data.tipoId} onChangeSelect={changeHandler}
                                    field='identificacion'
                                    fieldSelect='tipoId'
                                    title="Documento invalido"
                                />
                            }


                            <Input type="text" label='Nombres' field='nombre' value={data.nombre} onChange={changeHandler} pattern={letterPattern} />
                            <Input type="text" label='Apellidos' field='apellido' value={data.apellido} onChange={changeHandler} pattern={letterPattern} />

                            <Input label='Correo electrónico' field='email' value={data.email} onChange={changeHandler} />
                            <Input label='Celular' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999' field='celular' placeholder='0000-0000' value={data.celular} onChange={changeHandler} />
                            <br />
                            <div >
                                <input type="checkbox" name="" id="teminosycondiciones" required onChange={onAcceptChange} />
                                <label htmlFor="teminosycondiciones" style={{ textAlign: "justify" }}>
                                    Acepto términos y Condiciones
                                </label>
                            </div>


                        </DivRow>
                    </div>

                </form>
                <div className="align-r">
                    <DivRow width='100%'>
                        <button className="control-button-btn btn-next"
                            type="button"
                            onClick={sendNotification}
                            disabled={data.sendDisabled}
                        >¡Solicitar ahora!</button>
                    </DivRow>

                </div>

                <Modal
                    isOpen={data.showAcceptModel}
                    onRequestClose={closeAcceptModal}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <div className="dialog-center-content">
                        <div className="fontsize14">

                            <h2 className="h3 txt-primary txt-center">Términos y condiciones</h2>
                            <p style={{ textAlign: 'justify' }}>
                                Acepto que he leído y consecuentemente brindo mi consentimiento a SEGUROS LAFISE para el uso de mi información según lo indicado en las Políticas de Privacidad, Términos y Condiciones
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                El presente producto se encuentra registrado ante la SUGESE bajo el nombre de Incendio Hogar Riesgos nombrados Colones / Dólares y número de Registro G06-70-A14-591/G06-70-622 de Seguros.
                            </p>
                            <br />
                        </div>
                    </div>

                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeAcceptModal}>Aceptar</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={data.showDialogFinish}
                    onRequestClose={closeModalFinish}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    ariaHideApp={false}
                >

                    <div>
                        <div className="dialog-center-content">
                            <h2 className="text-center txt-primary">¡Tu solicitud ha sido <br /> recibida con éxito!</h2>
                        </div>
                        <div className="dialog-center-content">
                            <ImgAlertOk />
                        </div>
                        <div className="dialog-center-content">
                            <p className=" txt-muted txt-ft-12">Nos estaremos comunicando con vos lo antes posible.
                                <br />
                                <br />
                                Si deseas información adicional puedes ponerte en contacto al:
                                <br />
                                <br />
                                WhatsApp: 6094-7218 Opción 2 <br />
                                Teléfono: 2246-2700 Opción 6
                            </p>
                        </div>
                        <div className="mt-50"></div>
                        <div className="step">

                            <DivRow width="100%">
                                <div className="dialog-center-content">
                                    <button type="button" className="control-button-btn btn-color-primary" onClick={finalizar}>Ok</button>
                                </div>
                            </DivRow>
                        </div>


                    </div>

                </Modal>
            </div>


        </Container>




    );
}





export default Micrositio;
